import { render, staticRenderFns } from "./LoggedUser.vue?vue&type=template&id=560d6285&scoped=true"
import script from "./LoggedUser.vue?vue&type=script&lang=js"
export * from "./LoggedUser.vue?vue&type=script&lang=js"
import style0 from "./LoggedUser.vue?vue&type=style&index=0&id=560d6285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d6285",
  null
  
)

export default component.exports